export enum LOADER_OPTIONS {
  ADD = 'add',
  REMOVE = 'remove'
}

export enum LOADER_ENUM {
  CHAT_COMPONENT = 'chat_component',
  EXTRACTED_DETAILS = 'extracted_details',
  QUESTIONS_LIST = 'questions_list',
  ADD_TEMPLATE = 'add_template',
  EDIT_TEMPLATE  = 'edit_template',
  SUMMARY_RECOMENDATIONS = 'summary_recomendations'
}